/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Role_AdminInputs */



/**
* | output |
* | --- |
* | "Admin" |
*
* @param {Team_Manager_Role_AdminInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_role_admin = /** @type {((inputs?: Team_Manager_Role_AdminInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Role_AdminInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Administrateur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Administrator")
	if (locale === "it") return /** @type {LocalizedString} */ ("Amministratore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Администратор")
	if (locale === "es") return /** @type {LocalizedString} */ ("Administración")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("行政")
	if (locale === "ja") return /** @type {LocalizedString} */ ("管理者")
	if (locale === "hi") return /** @type {LocalizedString} */ ("व्यवस्थापक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Administrador")
	return /** @type {LocalizedString} */ ("Admin")
});